type LogFn = (message: string, context?: object) => void;

/**
 * For dependency-injecting loggers into business logic that
 * doesn't necessarily live in a server target, but needs proper logging
 **/
export interface InjectedLogger {
  debug: LogFn;
  info: LogFn;
  warn: LogFn;
  error: LogFn;
  exception: (message: string, error?: Error, context?: object) => void;
}

function noop() {}

export const noopInjectedLogger: InjectedLogger = {
  debug: noop,
  info: noop,
  warn: noop,
  error: noop,
  exception: noop,
};
